"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var CarPolicy_1 = require("../models/CarPolicy");
var mockCarPolicy = __assign(__assign({}, CarPolicy_1.makeEmptyCarPolicy()), { policyId: 10, policyStatus: '', effectiveStartDate: '12/12/2010', effectiveEndDate: '12/12/2100' });
exports.default = mockCarPolicy;
//# sourceMappingURL=mockCarPolicy.js.map